import { jsx as C } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ C(
  "path",
  {
    d: "M7.39853 2.29119C5.74808 1.28256 4.92284 0.778248 4.24294 0.837722C3.65018 0.889574 3.10823 1.19352 2.75489 1.67227C2.34961 2.22141 2.34961 3.18855 2.34961 5.12282V18.8771C2.34961 20.8113 2.34961 21.7785 2.75489 22.3276C3.10823 22.8064 3.65018 23.1104 4.24294 23.1622C4.92284 23.2216 5.74808 22.7173 7.39853 21.7087L18.652 14.8316C20.1841 13.8953 20.95 13.4272 21.2112 12.8246C21.4392 12.2984 21.4392 11.7014 21.2112 11.1753C20.95 10.5727 20.1841 10.1046 18.652 9.16831L7.39853 2.29119Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
export {
  r as default
};
